/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { getUsersBy } from './users.get.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  users: [],
  error: undefined,
};

/* Slice */
export const getUsersSlice = createSlice({
  name: 'getUsers',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getUsersBy.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(getUsersBy.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.users = action.payload;
        state.error = undefined;
      })
      .addCase(getUsersBy.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectUsersSlice = state => state[getUsersSlice.name];
export const selectUsers = createSelector(selectUsersSlice, s => s.users);
export const selectStatus = createSelector(selectUsersSlice, s => s.status);
